<div class="container-fluid h-100">
  <div class="row h-100 ">
    <div class="col-auto bg-white h-100">
      <Sidebar ref="sidebar"></Sidebar>
    </div>
    <div class="col bg-white h-100 m-0">
      <Navbar @toggle-sidebar="toggleSidebar"></Navbar>
      <div class="bg-gray px-4 py-1 h-100 scroll-container">
      <div class="bg-gray px-4 py-1 h-100">
        
          <div class="card bg-white shadow-sm mt-3 rounded-5 border-0">
            <div class="card-header bg-white rounded-5 border-0">
                <div class="card-header border-0 bg-white rounded-5 d-flex justify-content-between align-items-center">
                    <span class="fw-500">Manage Questions</span>
                    <button class="btn btn-warning text-white text-xs rounded-5 shadow-lg fw-500"
                       @click="assign_question()" >
                      <i class='bx bx-plus'></i> Assign Questions
                    </button>
                  </div>
                  
                <table id="questionsTable"class="table table-striped text-xxs mt-3">
                    <thead class="bg-dark text-white">
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Question</th>
                    <th scope="col">Type</th>
                    <th scope="col">Choice</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody class="text-black">
                  <tr v-for="(question, index) in questionDetails" :key="question.question_id">
                    <th scope="row">{{ index + 1 }}</th>
                    <td>{{ question.question_name }}</td>
                    <td>{{ question.question_type }}</td>
                    <td>
                    </td>
                    <td>
                        <input 
                        class="form-check-input ms-3" 
                        type="checkbox" 
                        :id="'question_check_' + question.question_id" 
                        :value="question.question_id" 
                        v-model="selectedQuestions"
                      />
                      <button
                        class="btn btn-primary text-xxs rounded-5 mx-1 btn-sm shadow ms-3"
                        
                      >
                        <i class="bi bi-pencil-square"></i> Edit
                      </button>
                      <button
                        class="btn btn-primary text-xxs rounded-5 mx-1 btn-sm shadow ms-3"
                        
                      >
                        <i class="bi bi-trash"></i> Delete
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>